import React, { useEffect, useState } from 'react';
import classnames from 'classnames/bind';
import { areEqual } from 'app/libs/lifeCycle';
import InputOblong from '../InputOblong';
import styles from './InputOblongGroup.module.scss';

const cx = classnames.bind(styles);

const InputOblongGroup = ({
	type,
	title = undefined,
	options = [],
	name,
	required = false,
	values = [],
	validation = false,
	validationTo = '을(를)',
	onChange = undefined,
	disabled = false,
	customErrorMessage = undefined,
	style = null,
}) => {
	const [selectValues, setSelectValues] = useState([]);

	const handleChangeCheckbox = (e) => {
		const { value } = e.target;

		const hasValue = selectValues.includes(value);

		if (hasValue) {
			const filteredValues = selectValues.filter((v) => v !== value);

			setSelectValues(filteredValues);

			if (onChange) {
				onChange(filteredValues);
			}

			return;
		}

		const changeValues = selectValues.concat(value);
		setSelectValues(changeValues);

		if (onChange) {
			onChange(changeValues);
		}
	};

	const handleChangeRadio = (e) => {
		const { value } = e.target;
		const changeValues = [value];
		setSelectValues(changeValues);

		if (onChange) {
			onChange(changeValues);
		}
	};

	useEffect(() => {
		if (!values.length) {
			return;
		}

		setSelectValues(values);
	}, [values]);

	return (
		<div
			className={cx('area')}
			style={style}
		>
			{title && <strong className={cx('title', { required })}>{title}</strong>}
			<div className={cx('list')}>
				{options.map(({ label, value }, i) => (
					<InputOblong
						disabled={disabled}
						key={value}
						classArray={[cx('item')]}
						target={selectValues[selectValues.indexOf(value)] || false}
						type={type}
						label={label}
						value={value}
						name={name}
						index={i}
						onChange={type === 'radio' ? handleChangeRadio : handleChangeCheckbox}
					/>
				))}
			</div>
			{validation && !selectValues.length && (
				<>
					{customErrorMessage ? (
						<p className={cx('error')}>{customErrorMessage}</p>
					) : (
						<p className={cx('error')}>
							{title}
							{validationTo} 선택해주세요.
						</p>
					)}
				</>
			)}
		</div>
	);
};

export default React.memo(InputOblongGroup, areEqual);
